<i
  *ngIf="showNurseDownloadedReport() && shouldShow()"
  data-testid="new-report-indicator"
  class="text-warning fa fa-exclamation-circle fa-2x align-middle"
  [title]="'measurementsGridTitleNewReport' | localize"></i>
<a
  *ngIf="shouldShow()"
  data-testid="download-report"
  target="report.pdf"
  class="btn btn-sm btn-success ms-2 me-2"
  [href]="getDownloadUrl('PRIMARY')"
  [title]="'measurementsGridButtonTitleDownloadReport' | localize"
  (click)="markReportDownloadedForNurse()">
  <i class="fa fa-download"></i>
</a>
<button
  *ngIf="shouldShowGenerateSleepReport()"
  data-testid="generate-sleep-report-button"
  type="button"
  class="btn btn-sm btn-success ms-2 me-2"
  [title]="'measurementsGridButtonTitleDownloadReport' | localize"
  (click)="generateSleepReport()">
  <i class="fa fa-download"></i>
</button>
